import styled from 'styled-components';
import ContentList from '../../ui-components/ContentList/ContentList';

export const CategoryContinueWatchingList = styled(ContentList)`
    margin-top: 20px;
    margin-bottom: 15px;
`;
